export { default } from './BlogPostsList';